import { createContext, useState, useContext } from "react";
import RecipeContext from "./recipe-context";
import ConvertContext from "./convert-context";
import ParseContext from "./parse-context";

const ImportRecipeContext = createContext({
  text: "",
  setText: (event) => {},
  importRecipe: () => {},
  selectedMeasurement: "",
  setSelectedMeasurement: () => {},
  toggleBool: false,
  setToggelBool: () => {},
});

export function ImportRecipeContextProvider(props) {
  const recipeContext = useContext(RecipeContext);
  const parseContext = useContext(ParseContext);
  const convertContext = useContext(ConvertContext);

  const [text, setText] = useState("");
  const [selectedMeasurement, setSelectedMeasurement] = useState("metric");
  const [toggleBool, setToggelBool] = useState(false);

  var item = [];

  var recipeName = "";

  var ingredients = [];
  var ingredientSection = false;

  var miseEnPlace = [];
  var miseEnPlaceSection = false;

  var method = [];
  var methodSection = false;

  var notes = [];
  var notesSection = false;
  const headers = {
    Ingredients: "Ingredients",
    MiseEnPlace: "Mise En Place",
    Method: "Method",
    Notes: "Notes",
  };

  function importRecipe() {
    createArrays();
    convertContext.convert(selectedMeasurement, toggleBool, ingredients);

    recipeContext.removeAll();
    recipeContext.updateName(recipeName);
    ingredients.forEach(recipeContext.addIngredient);
    miseEnPlace.forEach(recipeContext.addMiseEnPlace);
    method.forEach(recipeContext.addMethod);
    notes.forEach(recipeContext.addNote);
  }

  function createArrays() {
    var separateLines = text.split(/\r?\n|\r|\n/g);
    if (separateLines[separateLines.length - 1] !== "") {
      separateLines.push("");
    }

    recipeName = separateLines[0];
    separateLines.shift();
    separateLines.shift();

    separateLines.forEach((line) => {
      if (
        line.toLocaleLowerCase() === headers.MiseEnPlace.toLocaleLowerCase() ||
        line.toLocaleLowerCase() === headers.Method.toLocaleLowerCase() ||
        line.toLocaleLowerCase() === headers.Notes.toLocaleLowerCase() ||
        line.toLocaleLowerCase() === headers.Ingredients.toLocaleLowerCase()
      ) {
        ingredientSection = false;
        miseEnPlaceSection = false;
        methodSection = false;
        notesSection = false;
      }

      buildIngredentSectionArray(line);
      buildSectionArray(miseEnPlaceSection, miseEnPlace, line);
      buildSectionArray(methodSection, method, line);
      buildSectionArray(notesSection, notes, line);

      if (
        line.toLocaleLowerCase() === headers.Ingredients.toLocaleLowerCase()
      ) {
        ingredientSection = true;
      }
      if (
        line.toLocaleLowerCase() === headers.MiseEnPlace.toLocaleLowerCase()
      ) {
        miseEnPlaceSection = true;
        item = [];
      }
      if (line.toLocaleLowerCase() === headers.Method.toLocaleLowerCase()) {
        methodSection = true;
        item = [];
      }
      if (line.toLocaleLowerCase() === headers.Notes.toLocaleLowerCase()) {
        notesSection = true;
        item = [];
      }
    });
  }

  function buildIngredentSectionArray(line) {
    if (ingredientSection) {
      if (line !== "") {
        const amountResults = parseContext.parseAmount(line);
        const amount = amountResults.amount;
        line = amountResults.line.trimStart();

        const unitResults = parseContext.parseUnit(line);
        const unit = unitResults.unit;
        const name = unitResults.line.trimStart();

        ingredients.push({
          amount: amount,
          unit: unit,
          name: name,
        });
      }
    }
  }

  function buildSectionArray(bool, array, line) {
    if (bool) {
      if (line !== "") {
        item.push(line);
      }
      if (line === "") {
        array.push(item.join("\n"));
        item = [];
      }
    }
  }

  const context = {
    text: text,
    setText: setText,
    importRecipe: importRecipe,
    selectedMeasurement: selectedMeasurement,
    setSelectedMeasurement: setSelectedMeasurement,
    toggleBool: toggleBool,
    setToggelBool: setToggelBool,
  };

  return (
    <ImportRecipeContext.Provider value={context}>
      {props.children}
    </ImportRecipeContext.Provider>
  );
}

export default ImportRecipeContext;
